import { render, staticRenderFns } from "./oilCzInfo.vue?vue&type=template&id=5a4ab9a0&scoped=true&"
import script from "./oilCzInfo.vue?vue&type=script&lang=js&"
export * from "./oilCzInfo.vue?vue&type=script&lang=js&"
import style0 from "./oilCzInfo.vue?vue&type=style&index=0&id=5a4ab9a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4ab9a0",
  null
  
)

export default component.exports